module.exports = __webpack_public_path__ + "img/l-hd.679c0f2e.webp";